import { Center, Spinner } from "@chakra-ui/react"
import { AuthContainerProps } from "@pathwright/auth/src/views/auth/AuthContainer"
import React, { Suspense } from "react"

const AdaptedAuthContainer = React.lazy(
  () =>
    import(
      "./AdaptedAuthContainer" /* webpackChunkName: "AdaptedAuthContainer" */
    )
)

function LazyAdaptedAuthContainer(props: AuthContainerProps) {
  return (
    <Suspense
      fallback={
        <Center w="full" h="full" flex={1}>
          <Spinner />
        </Center>
      }
    >
      <AdaptedAuthContainer {...props} />
    </Suspense>
  )
}

export default LazyAdaptedAuthContainer
